"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const dataLayer_1 = require("../../helper/dataLayer");
const NotificationStore_1 = __importDefault(require("../../stores/NotificationStore"));
const Backdrop_1 = __importDefault(require("../Backdrop"));
const NotificationDropdown_1 = __importDefault(require("./NotificationDropdown"));
class NotificationButton extends react_1.default.Component {
    toggleDropdown = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            toggleDropdown: mobx_1.observable,
            showDropdown: mobx_1.computed,
        });
    }
    get showDropdown() {
        return this.toggleDropdown && NotificationStore_1.default.hasNotifications;
    }
    componentDidMount() {
        NotificationStore_1.default.initialize();
        NotificationStore_1.default.loadNotifications();
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onHideDropdown);
    }
    render() {
        const { className } = this.props;
        const buttonVariant = NotificationStore_1.default.hasNotifications ? ButtonVariant_1.default.primary : ButtonVariant_1.default.light;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-notifications-button', className), onClick: this.onToggleDropdown },
                react_1.default.createElement(Button_1.default, { variant: buttonVariant, icon: Zupicons_1.default.bell, disabled: !NotificationStore_1.default.hasNotifications }),
                NotificationStore_1.default.hasNotifications ? (react_1.default.createElement("div", { className: "znd-top-bar__icon-button-notifications__badge" },
                    react_1.default.createElement("span", { className: "znd-top-bar__icon-button-notifications__badge__content t-body-small font-weight-bold" }, NotificationStore_1.default.notificationsCount))) : null,
                this.showDropdown ? react_1.default.createElement(NotificationDropdown_1.default, null) : null),
            react_1.default.createElement(Backdrop_1.default, { className: "znd-main-navigation__backdrop-notification", showBackdrop: this.showDropdown, onHideBackdrop: this.onHideDropdown })));
    }
    onToggleDropdown() {
        if (!NotificationStore_1.default.hasNotifications) {
            return;
        }
        this.toggleDropdown = !this.toggleDropdown;
        if (this.toggleDropdown) {
            (0, dataLayer_1.pushToDataLayer)({
                event: DataLayerEvents_1.default.dlvClickNotificationList,
            });
            setImmediate(() => {
                document.addEventListener('click', this.onHideDropdown);
            });
        }
        else {
            document.removeEventListener('click', this.onHideDropdown);
        }
    }
    onHideDropdown() {
        this.toggleDropdown = false;
        document.removeEventListener('click', this.onHideDropdown);
    }
}
__decorate([
    bind_decorator_1.default
], NotificationButton.prototype, "onToggleDropdown", null);
__decorate([
    bind_decorator_1.default
], NotificationButton.prototype, "onHideDropdown", null);
exports.default = (0, mobx_react_1.observer)(NotificationButton);
